export default __webpack_public_path__ + "static/media/featMb.c038825f.png";